export default {
  button: {
    id: 'press_carousel_button',
    defaultMessage: 'See all the buzz',
  },
}
